const EllipsisVertical = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-ellipsis-vertical"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-ellipsis-vertical"
      viewBox="0 0 512 512"
      width={_width}
      {...props}
    >
      <g>
        <circle cx="256" cy="53.333" r="53.333" />
        <circle cx="256" cy="256" r="53.333" />
        <circle cx="256" cy="458.667" r="53.333" />
      </g>
    </svg>
  );
};

export default EllipsisVertical;
